module.exports = __webpack_public_path__ + "img/no-data-img.9b4df102.png";